import { Box, ProgressBar } from '@alf/uikit';
import { PROGRESS_BAR_STATES_COLORS } from '../../constants';
import ProgressTitle from './components/ProgressTitle';

import styles from './index.module.css';

const WagerProgressBar = ({
  bonus,
  className = '',
  status,
  isWagerEnabled,
  ...props
}) => {
  const { outputBetTotal, outputMaxTotal } = bonus;

  if (!isWagerEnabled) {
    return null;
  }

  return (
    <Box
      justify="center"
      align="center"
      direction="column"
      data-testid="wager-progress-bar"
      className={`${styles[status]} ${styles.progressBarWrapper}`}
    >
      <ProgressTitle bonus={bonus} status={status} />
      <ProgressBar
        {...props}
        currentValue={Number(outputBetTotal)}
        totalValue={Number(outputMaxTotal)}
        progressColor={PROGRESS_BAR_STATES_COLORS[status]}
        classNames={{
          containerClassName: `${styles.wageringProgressBar} ${styles[status]} ${className}`
        }}
      />
    </Box>
  );
};

export default WagerProgressBar;
